import React, { useState, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Input, Label, FormGroup, Row, Col } from 'reactstrap';
import moment from 'moment';

const NewTimeslotModal = ({ isOpen, toggle, onSave, scheduleId, serviceDuration }) => {
  const [newTimeslot, setNewTimeslot] = useState({
    schedule: scheduleId,
    start: '',
    end: ''
  });

  const computedEnd = useMemo(() => {
    if (!newTimeslot.start || !serviceDuration) {
      return '';
    }
    return moment(newTimeslot.start, 'HH:mm')
      .add(serviceDuration, 'minutes')
      .format('HH:mm');
  }, [newTimeslot.start, serviceDuration]);

  const handleSave = () => {
    // Convert HH:mm to HH:mm:ss for backend
    const timeslotData = {
      ...newTimeslot,
      start: newTimeslot.start ? `${newTimeslot.start}:00` : '',
      end: computedEnd ? `${computedEnd}:00` : ''
    };
    onSave(timeslotData);
    setNewTimeslot({ schedule: scheduleId, start: '', end: '' });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewTimeslot(prev => ({ ...prev, [name]: value }));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Add New Timeslot</ModalHeader>
      <ModalBody>
        <Row>
          <Col md={6}>
            <FormGroup>
              <Label for="start">Start Time *</Label>
              <Input
                type="time"
                id="start"
                name="start"
                value={newTimeslot.start}
                onChange={handleChange}
                required
              />
            </FormGroup>
          </Col>
          <Col md={6}>
            <FormGroup>
              <Label for="end">End Time</Label>
              <Input
                type="time"
                id="end"
                name="end"
                value={computedEnd}
                readOnly
                disabled
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSave} disabled={!newTimeslot.start || !serviceDuration}>
          Add Timeslot
        </Button>{' '}
        <Button color="secondary" onClick={toggle}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default NewTimeslotModal;
